import React from "react"

const Spinner = ({isLoadeding}) => (
    <div className={`lds-spinner ${(isLoadeding ? 'loading' : '')} `}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
)

export default Spinner